import SwitchLanguageSFC from "./SwitchLanguage.vue";
export const SwitchLanguage = SwitchLanguageSFC;
